import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const feedbackInitiateTranslation = createAction("".concat(stateName, "/feedbackInitiateTranslation"));